// extracted by mini-css-extract-plugin
export default {"block":"index_block_UhdjO"};